import React from 'react';
import Axios from 'axios';
import moment from 'moment';

import Users from './Users';
import AutoSuggestPlayer from '../shared/AutoSuggest/AutoSuggestPlayer';

const autoSuggTheme = {
	container: 'react-autosuggest-std__container',
	input: 'react-autosuggest-std__input',
	inputOpen: 'react-autosuggest-std__input--open',
	inputFocused: 'react-autosuggest-std__input--focused',
	suggestionsContainer: 'react-autosuggest-std__suggestions-container',
	suggestionsContainerOpen: 'react-autosuggest-std__suggestions-container--open',
	suggestionsList: 'react-autosuggest-std__suggestions-list',
	suggestion: 'react-autosuggest-std__suggestion',
	suggestionHighlighted: 'react-autosuggest-std__suggestion--highlighted',
	//suggestionFirst: 'react-autosuggest__suggestion--first',
	//sectionContainer: 'react-autosuggest__section-container',
	//sectionContainerFirst: 'react-autosuggest__section-container--first',
	//sectionTitle: 'react-autosuggest__section-title'
};

class Profile extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			profile: this.props.auth.getProfile(),
			isAuthenticated: this.props.auth.isAuthenticated(),

			user: {
				playerId: 0,
				playerName: '',
				streetaddress: '',
				addresslevel1: '',
				addresslevel2: '',
				postalcode: '',
				country: '',
				tel: '',
				email: '',
			},
			players: [],
			loading: true,
			statsProfilePlayerEnable: false
			};
	
		this.handleUserChange = this.handleUserChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handlePlayerChange = this.handlePlayerChange.bind(this);
	}

	componentDidMount() {
		// console.log('Profile: componentDidMount');

		// Get playerId and info
		var _this = this;
		var profile = this.state.profile;

		// Debug - user another authUserId
		var authUserId = profile.user_id;

		if (authUserId !== undefined) {
			Users.getUserInfo(authUserId, function(user) {

				user.authUserId = profile.user_id;

				// Force dropdown select valiation on null value
				var statsProfilePlayerEnable = true;

				if(user.playerId.toString() === '0') {
					user.playerId = '';
					statsProfilePlayerEnable = false;
				}
				
        Axios.get('/api/players').then(function (responsePlayers) {
					_this.setState({
						user: user,
            players: responsePlayers.data,
            loading: false,
            statsProfilePlayerEnable: statsProfilePlayerEnable
					});
				});
			});
		}
	}

	render() {
		// console.log('Profile: render')
		return (
			<div className="animated fadeIn">
				{this.displayModule()}
			</div>
		);
	}

	displayModule() {
		var profile = this.state.profile;
		var user = this.state.user;

		if (!this.state.isAuthenticated) {
			return (
				<div>
					<p>Vous devez être connecté pour visualiser votre profil.<br/>
					Cliquez sur <b>Se connecter</b> dans la barre de gauche.<br/></p>
				</div>
			);
		} else {
			return (
				<div>
				<div className="row">
					<div className="col-md-5">
		        		<h5>{this.state.user.playerName}</h5>
					</div>
					<div className="col-md-6">
		        		<h5>Votre Compte</h5>
					</div>

					<div className="col-md-1">
						<img className="img-circle" src={profile.picture} />
					</div>
	       		</div>
				<hr/>

				<div className="row">
        <div className="col-md-8">
        <form className="form-horizontal" onSubmit={this.handleSubmit}>

					<div className="form-group">
          <div className="row">
          <div className="col-md-12">
            <h5>Informations Utilisateur</h5>
					</div>
					</div>
					</div>

					{this.displayProfile(user)}

					<button type="submit" className="btn btn-primary">Sauvegarder</button>
				</form>
				</div>
				</div>
				</div>
			)
		}
	}

	displayProfile(user) {
		if (this.state.loading) {
			return ( this.displaySpinner() );
		} else {
			return ( this.displayData(user) );
		}
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

	// https://www.w3schools.com/tags/att_form_autocomplete.asp
	// https://developers.google.com/web/fundamentals/design-and-ux/input/forms/#recommended_input_name_and_autocomplete_attribute_values
	displayData(user) {
		return (
			<div>
				<div className="form-group">
        <div className="row">
        <div className="col-md-8">
					<label htmlFor="name" className="labelSmallMarginBottom"> Nom </label>
					<input type="text" className="form-control" name="name" id="name" placeholder="Prénom et Nom" 
						value={user.name || ''} onChange={this.handleUserChange} required autoComplete="name"/>
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-8">
					<label htmlFor="streetaddress" className="labelSmallMarginBottom"> Adresse (no et rue) </label>
					<input type="text" className="form-control" name="streetaddress" id="streetaddress" placeholder="" 
						value={user.streetaddress || ''} onChange={this.handleUserChange} required autoComplete="street-address"/>
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-8">
					<label htmlFor="addresslevel2" className="labelSmallMarginBottom"> Ville </label>
					<input type="text" className="form-control" name="addresslevel2" id="addresslevel2" placeholder="" 
						value={user.addresslevel2 || ''} onChange={this.handleUserChange} required autoComplete="address-level2"/>
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-8">
					<label htmlFor="addresslevel1" className="labelSmallMarginBottom"> Province / État </label>
					<input type="text" className="form-control" name="addresslevel1" id="addresslevel1" placeholder="" 
						value={user.addresslevel1 || ''} onChange={this.handleUserChange} required autoComplete="address-level1"/>
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-8">
					<label htmlFor="postalcode" className="labelSmallMarginBottom"> Code postal </label>
					<input type="text" className="form-control" name="postalcode" id="postalcode" placeholder="A0A 0A0" 
						value={user.postalcode || ''} onChange={this.handleUserChange} required autoComplete="postal-code"/>
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-8">
					<label htmlFor="country" className="labelSmallMarginBottom"> Pays </label>
					<input type="text" className="form-control" name="country" id="country" placeholder="" 
						value={user.country || ''} onChange={this.handleUserChange} required autoComplete="country"/>
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-8">
					<label htmlFor="email" className="labelSmallMarginBottom">Courriel</label>
					<input type="email" className="form-control" name="email" id="email" placeholder="" 
						value={user.email || ''} onChange={this.handleUserChange} required autoComplete="email"/>
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-8">
					<label htmlFor="tel" className="labelSmallMarginBottom">Téléphone</label>
					<input type="tel" className="form-control" name="phone" id="tel" placeholder="000-000-0000" 
						value={user.tel || ''} onChange={this.handleUserChange} required autoComplete="tel"/>
				</div>
				</div>
				</div>

				<div className="form-group">
        <div className="row">
        <div className="col-md-8">
					<label htmlFor="playerId" className="labelSmallMarginBottom"> PROFIL STATISTIQUE </label><br/>
					<p>(entrer quelques lettres de votre prénom ou de votre nom de famille et rechercher votre profile 
						dans la liste de joueurs qui apparaîtra)</p>					

					<AutoSuggestPlayer theme={autoSuggTheme} playerId={user.playerId} dataChange={this.handlePlayerChange} />
					(Vous de pourrez pas changer cette entrée par la suite contactez Statelo si vous avez fait une erreur de sélection)

				</div>
				</div>
				</div>

			</div>
		);
	}

	handleUserChange(e) {
		// console.log("Profile: handleUserChange");
		// console.log(e.target.value);
		var user = this.state.user;
		var userProp = e.target.id;
		user[userProp] = e.target.value;
        
    this.setState({
    	user: user
    });
	}

	handlePlayerChange(dataValue) {
		// console.log("Profile: handlePlayerChange");
		var user = this.state.user;

		if(this.state.statsProfilePlayerEnable) {
			alert("Vous ne pouvez pas changer cette entrée.");
			
			this.setState({
				user: user
			});

		} else {
			user.playerId = dataValue; 

			this.setState({
				user: user
			});
		}
	}

	handleSubmit(e) {
		e.preventDefault();
		var _this = this;
		var userData = this.state.user;
		
		if(userData.playerId === "") {
			alert("Vous devez spécifier un Profil Statisque existant et valide")
		} else {

			userData.userUpdated = true;		// update this flag to have a valid profile info (updated by user)

			var userId = userData._id;
			delete userData._id;

			// console.log('SAVE');
			// console.log(userData);

			Axios.post('/api/users/modifyUserData/' + userData.authUserId, {
				userData: userData,
			})
			.then(function(response) {
				const path = '/userAccount';
				_this.props.history.push(path);
			})
			.catch(function(error) {
				console.log('ERROR');
				console.log(error);
			});
		}
	}

}

export default Profile;

// https://developers.google.com/web/fundamentals/design-and-ux/input/forms/#recommended_input_name_and_autocomplete_attribute_values

// https://github.com/JedWatson/react-select/blob/master/examples/src/components/Virtualized.js

// http://jedwatson.github.io/react-select/